import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// We are not importing index.css because it wasn't in your file list
// If you have global styles, you can add them later.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);